"use client";
import React, { useState } from "react";

import { Header } from "@/sections/Header";
import { Footer } from "@/sections/Footer";
import { PageContainer, Content } from "./styles";

import { PageLayoutProps } from "./types";
import { SimpleMenu } from "@/components/SimpleMenu";
import { ContactFabButton } from "@/components/buttons/ContactFabButton";

export const PageLayout = ({
  hideFooter = false,
  showBottomCTA = false,
  children,
  showIATA,
  disableHeaderShadow = false,
  menuItems,
  messages,
  announcement,
  siteConfig,
  ...props
}: PageLayoutProps) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpened(!isMenuOpened);
  };
  return (
    <PageContainer
      {...props}
      isMenuOpened={isMenuOpened}
      addBottomPadding={showBottomCTA}
    >
      <Header
        disableShadow={disableHeaderShadow}
        {...{ isMenuOpened, toggleMenu, announcement, config: siteConfig }}
      />
      <Content>{children}</Content>
      {!hideFooter && <Footer {...{ showIATA, config: siteConfig }} />}
      <ContactFabButton siteConfig={siteConfig} />
      {!!menuItems && (
        <SimpleMenu
          messages={{...messages, ...siteConfig}}
          isOpened={isMenuOpened}
          onClose={() => setIsMenuOpened(false)}
          menuItems={menuItems}
        />
      )}
    </PageContainer>
  );
};
